import { HttpClient, HttpContext } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { ResultatsCalculDTO, ResultatsCalculDTOSchema } from "@mra/hlp9002";
import { Observable } from "rxjs";
import { Beneficiaire } from "src/app/models/beneficiaire.model";
import { environment } from "../../../../environments/environment";
import { VALIDATION_SCHEMA_CONTEXT } from "../api/http-format-interceptor.service";

@Injectable({
    providedIn: "root"
})
export class RenteCalculService {
    private readonly http = inject(HttpClient);
    private readonly context: HttpContext = new HttpContext().set(VALIDATION_SCHEMA_CONTEXT, ResultatsCalculDTOSchema);

    /**
     * calcul la rente en fonction de la configuration actuellement sélectionnée
     * @param coutOptions - si on souhaite le montant de rente avec ou sans option
     * @param options - liste des options
     * @param consommationCapital - consommation de l'épargne par la sortie en capital
     * @returns résultats de calcul de la rente
     */
    renteCalcul(
        dateEffet: string,
        consommationRente: number,
        consommationCapital: number,
        beneficiaire: Beneficiaire,
        coutOptions: boolean = false,
        options: string[] = []
    ): Observable<ResultatsCalculDTO> {
        const params: Record<string, string | number | boolean | string[]> = {
            coutOptions,
            dateEffet,
            montantEpargne: consommationRente,
            options,
            consommationCapital
        };
        if (beneficiaire?.dateNaissance) {
            params.conjointDateNaissance = beneficiaire.dateNaissance;
        }
        if (beneficiaire?.civilite) {
            params.conjointSexeCode = beneficiaire.civilite;
        }
        return this.http.get<ResultatsCalculDTO>(environment.urlsMs.MS0202, {
            context: this.context,
            params
        });
    }
}
